import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';

@Pipe({
    name: 'timeago',
    standalone: false
})
export class TimeAgoPipe implements PipeTransform {
    transform(value: Date): string {
        if (!value) {
            return '';
        }
        return moment(value).fromNow();
    }
}
